import React from "react";
import { connect } from "react-redux";
import Form from "./crew-event-form";
import { addShootingDayScheduleEvent } from "./ducks/actions";

function AddScheduleEvent(props) {
  const { filmId, shootingdayId } = props;
  const {
    fetchScheduleEventSettings,
    addShootingDayScheduleEvent,
    errors,
  } = props;

  function onAddScheduleEvent(scheduleEvent) {
    scheduleEvent.type = scheduleEvent.isMealEvent ? 2 : 3;
    sanitiseDataTypes(scheduleEvent);
    addShootingDayScheduleEvent(filmId, shootingdayId, scheduleEvent);
  }

  function sanitiseDataTypes(ScheduleEvent) {}

  return (
    <div className="blade-content">
      <Form
        mode="add"
        errors={errors}
        ScheduleEventId={null}
        initialValues={null}
        loading={false}
        onSubmit={onAddScheduleEvent}
        {...props}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    errors: state.shootingdaysState.scheduleState.errors,
  };
}

export default connect(mapStateToProps, {
  addShootingDayScheduleEvent,
})(AddScheduleEvent);
